import { Link } from "react-router-dom";
import { Phone, EnvelopeSimple, MapPin } from "@phosphor-icons/react";
import { COMPANY, NAV_LINKS, SERVICES } from "@/lib/siteData";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1A1A18] text-[#F6F5F2]">
      <div className="container-fz py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-9 h-9 grid place-items-center bg-[#D05322] text-[#F6F5F2] font-display">
                FE
              </span>
              <span className="font-display text-xl tracking-tight">
                Fitzgerald<span className="text-[#D05322]">.</span>Earthworks
                <span className="text-stone-500 text-xs ml-1.5 align-top">LTD</span>
              </span>
            </div>
            <p className="text-stone-400 max-w-md leading-relaxed">
              Family-owned earthmoving contractor based in Mangatangi.
              Reliable excavation, drainage, site preparation and land
              development across the Waikato, Auckland and Hauraki regions.
            </p>
            <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-xs uppercase tracking-[0.22em] text-stone-500">
              <span>20+ Years Experience</span>
              <span>Family Operated</span>
              <span>Waikato, Auckland & Hauraki</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-stone-500 mb-5">Pages</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="text-stone-300 hover:text-[#D05322] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="eyebrow text-stone-500 mb-5">Contact</p>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Phone size={20} className="text-[#D05322] mt-0.5" />
                <a
                  href={COMPANY.phoneHref}
                  data-testid="footer-phone"
                  className="text-stone-200 hover:text-[#D05322]"
                >
                  {COMPANY.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <EnvelopeSimple size={20} className="text-[#D05322] mt-0.5" />
                <a
                  href={COMPANY.emailHref}
                  data-testid="footer-email"
                  className="text-stone-200 hover:text-[#D05322] break-all"
                >
                  {COMPANY.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={20} className="text-[#D05322] mt-0.5" />
                <span className="text-stone-200">
                  {COMPANY.location}<br />Serving {COMPANY.region}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-stone-800 flex flex-col md:flex-row gap-4 md:items-center md:justify-between">
          <p className="text-xs text-stone-500 tracking-wide">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-xs text-stone-500 tracking-[0.18em] uppercase">
            Reliable. Practical. Built to last.
          </p>
        </div>
      </div>
    </footer>
  );
}
